import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import { toastError, toastSuccess } from '@components/Toast';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';
import { getOrderDetailsInfo } from '@store/reducers';

import ApiClient from '@lib/apiClient';

const RequestConfirmation = ({ onCloseModal, requestedType = 'ORDER', rfqIdList = [] }) => {
	const [remarks, setRemarks] = useState('');
	const [isRequestConfirmation, setIsRequestConfirmation] = useState(true);
	const { id } = useParams();
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const orderDetailsInfo = useSelector(getOrderDetailsInfo);

	useEffect(() => {
		setIsRequestConfirmation(orderDetailsInfo?.isPaymentDocumentRequested);
	}, [orderDetailsInfo]);

	const handleSubmit = () => {
		dispatch(openLoader());
		let postData = {
			orderId: parseInt(id),
			requestedType,
			remarks
		};
		if (rfqIdList.length > 0 && requestedType !== 'ORDER') {
			postData['rfqIdList'] = rfqIdList;
		}
		ApiClient.POST('orderCancelRequest', postData)
			.then((response) => {
				dispatch(closeLoader());
				if (response.data.message === 'Canceled') {
					if (requestedType !== 'ORDER') {
						toastSuccess('Style deleted');
					} else {
						toastSuccess('Order deleted');
					}
					navigate('/orders/my-orders?active=CANCEL');
				} else {
					toastSuccess('Request sent!');
				}
				onCloseModal();
			})
			.catch((error) => {
				dispatch(closeLoader());
				toastError(error.response.data.message);
			});
	};

	return (
		<Modal show={true} onHide={onCloseModal} centered className="request-confirmation-modal">
			<div className="add-new-popup">
				<Modal.Header closeButton>
					{isRequestConfirmation && <h3 className="semibold-16">Request Confirmation </h3>}
				</Modal.Header>
				<Modal.Body>
					<section>
						<div className="popup-body">
							<div className="popup-body-content">
								{isRequestConfirmation && (
									<div className="container-fluid px-0">
										<p>
											Your cancel request will be forwarded to country head for
											approval.
										</p>
										<p className="mb-2">Do you want to proceed?</p>

										<div className="row">
											<div className="col-md-12">
												<textarea
													placeholder={'Explain why are you canceling'}
													value={remarks}
													onChange={(e) => setRemarks(e.target.value)}
												/>
											</div>
										</div>
									</div>
								)}
								{!isRequestConfirmation && (
									<div className="container-fluid px-0">
										<p className="semibold-14">
											This order/style will be deleted. Are you sure about this?
										</p>
									</div>
								)}
							</div>
						</div>
					</section>
				</Modal.Body>
				<Modal.Footer>
					<div className="popup-footer">
						<div className="buttons text-right">
							<button className="button gray-outline size32" onClick={onCloseModal}>
								Cancel
							</button>
							<button className="button size32" onClick={handleSubmit}>
								Submit
							</button>
						</div>
					</div>
				</Modal.Footer>
			</div>
		</Modal>
	);
};

export default RequestConfirmation;
